import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Desarrollo Web",
          "Diseño Web",
          "Desarrollo de Aplicaciones",
          "Base de Datos",
          "Infraestructura Cloud",
          "Consultorías IT",
          "Ciberseguridad",
          "Soporte IT"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
